export const jobworkingdayConstants = [
  '裁量労働制',
  '週5日',
  '週3〜4日',
  '週1〜2日',
  '指定なし',
];
